"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * sls-lambda
 * REST API definition for Service Location Service.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * DefaultApi - axios parameter creator
 * @export
 */
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Accepts a list of body IDs and returns the current location the body is connected to. If the service could not determine the current location, the bodyId is omitted from the response. This maps to the slsBodyCurrentEndpointSearch API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {Array<string>} bodyIds An array of body IDs.
         * @param {string} originRequestId A unique request identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceCurrentEndpointSearch: function (applicationName, bodyIds, originRequestId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationName' is not null or undefined
                    (0, common_1.assertParamExists)('serviceCurrentEndpointSearch', 'applicationName', applicationName);
                    // verify required parameter 'bodyIds' is not null or undefined
                    (0, common_1.assertParamExists)('serviceCurrentEndpointSearch', 'bodyIds', bodyIds);
                    // verify required parameter 'originRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('serviceCurrentEndpointSearch', 'originRequestId', originRequestId);
                    localVarPath = "/serviceCurrentEndpoints";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (bodyIds) {
                        localVarQueryParameter['bodyIds'] = bodyIds;
                    }
                    if (applicationName !== undefined && applicationName !== null) {
                        localVarHeaderParameter['ApplicationName'] = String(applicationName);
                    }
                    if (originRequestId !== undefined && originRequestId !== null) {
                        localVarHeaderParameter['Origin-RequestId'] = String(originRequestId);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Accepts a group name and returns the inception datacenter and morpheus environment for the mrpcsecure service assigned to that group.  This API is a special case used by the provisioning system to determine which environment a body using the specified group will be assigned to so that it can perform some actions specific to that environment.
         * @param {string} dialCodeGroupName The dial code group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceDatacenterEnvironmentGet: function (dialCodeGroupName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dialCodeGroupName' is not null or undefined
                    (0, common_1.assertParamExists)('serviceDatacenterEnvironmentGet', 'dialCodeGroupName', dialCodeGroupName);
                    localVarPath = "/serviceDatacenterEnvironment/{dialCodeGroupName}"
                        .replace("{".concat("dialCodeGroupName", "}"), encodeURIComponent(String(dialCodeGroupName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns the service endpoint for the specified body and service. This maps to the slsServiceEndpointGet API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} bodyId The ID of a body.
         * @param {string} originRequestId A unique request identifier.
         * @param {string} service The name of a specific service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointGet: function (applicationName, bodyId, originRequestId, service, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationName' is not null or undefined
                    (0, common_1.assertParamExists)('serviceEndpointGet', 'applicationName', applicationName);
                    // verify required parameter 'bodyId' is not null or undefined
                    (0, common_1.assertParamExists)('serviceEndpointGet', 'bodyId', bodyId);
                    // verify required parameter 'originRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('serviceEndpointGet', 'originRequestId', originRequestId);
                    // verify required parameter 'service' is not null or undefined
                    (0, common_1.assertParamExists)('serviceEndpointGet', 'service', service);
                    localVarPath = "/serviceEndpoints/{service}"
                        .replace("{".concat("service", "}"), encodeURIComponent(String(service)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (applicationName !== undefined && applicationName !== null) {
                        localVarHeaderParameter['ApplicationName'] = String(applicationName);
                    }
                    if (bodyId !== undefined && bodyId !== null) {
                        localVarHeaderParameter['BodyId'] = String(bodyId);
                    }
                    if (originRequestId !== undefined && originRequestId !== null) {
                        localVarHeaderParameter['Origin-RequestId'] = String(originRequestId);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns all service endpoints for the specified body. This maps to the slsServiceEndpointSearch API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} bodyId The ID of a body.
         * @param {string} originRequestId A unique request identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointSearch: function (applicationName, bodyId, originRequestId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationName' is not null or undefined
                    (0, common_1.assertParamExists)('serviceEndpointSearch', 'applicationName', applicationName);
                    // verify required parameter 'bodyId' is not null or undefined
                    (0, common_1.assertParamExists)('serviceEndpointSearch', 'bodyId', bodyId);
                    // verify required parameter 'originRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('serviceEndpointSearch', 'originRequestId', originRequestId);
                    localVarPath = "/serviceEndpoints";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (applicationName !== undefined && applicationName !== null) {
                        localVarHeaderParameter['ApplicationName'] = String(applicationName);
                    }
                    if (bodyId !== undefined && bodyId !== null) {
                        localVarHeaderParameter['BodyId'] = String(bodyId);
                    }
                    if (originRequestId !== undefined && originRequestId !== null) {
                        localVarHeaderParameter['Origin-RequestId'] = String(originRequestId);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns a list of service endpoints that are global to the region.  The same list is returned for all callers.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} originRequestId A unique request identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceGlobalEndpointSearch: function (applicationName, originRequestId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationName' is not null or undefined
                    (0, common_1.assertParamExists)('serviceGlobalEndpointSearch', 'applicationName', applicationName);
                    // verify required parameter 'originRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('serviceGlobalEndpointSearch', 'originRequestId', originRequestId);
                    localVarPath = "/serviceGlobalEndpoints";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (applicationName !== undefined && applicationName !== null) {
                        localVarHeaderParameter['ApplicationName'] = String(applicationName);
                    }
                    if (originRequestId !== undefined && originRequestId !== null) {
                        localVarHeaderParameter['Origin-RequestId'] = String(originRequestId);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns an ordered list of service endpoints for the servicelogin service for the specified body. This maps to the slsServiceLoginEndpointSearch API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} originRequestId A unique request identifier.
         * @param {string} [deviceType] The device type of a body.
         * @param {string} [domain] The domain of a body.
         * @param {string} [softwareVersion] The software version of a body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLoginEndpointSearch: function (applicationName, originRequestId, deviceType, domain, softwareVersion, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationName' is not null or undefined
                    (0, common_1.assertParamExists)('serviceLoginEndpointSearch', 'applicationName', applicationName);
                    // verify required parameter 'originRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('serviceLoginEndpointSearch', 'originRequestId', originRequestId);
                    localVarPath = "/serviceLoginEndpoints";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (deviceType !== undefined) {
                        localVarQueryParameter['deviceType'] = deviceType;
                    }
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (softwareVersion !== undefined) {
                        localVarQueryParameter['softwareVersion'] = softwareVersion;
                    }
                    if (applicationName !== undefined && applicationName !== null) {
                        localVarHeaderParameter['ApplicationName'] = String(applicationName);
                    }
                    if (originRequestId !== undefined && originRequestId !== null) {
                        localVarHeaderParameter['Origin-RequestId'] = String(originRequestId);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         * Accepts a list of body IDs and returns the current location the body is connected to. If the service could not determine the current location, the bodyId is omitted from the response. This maps to the slsBodyCurrentEndpointSearch API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {Array<string>} bodyIds An array of body IDs.
         * @param {string} originRequestId A unique request identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceCurrentEndpointSearch: function (applicationName, bodyIds, originRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceCurrentEndpointSearch(applicationName, bodyIds, originRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Accepts a group name and returns the inception datacenter and morpheus environment for the mrpcsecure service assigned to that group.  This API is a special case used by the provisioning system to determine which environment a body using the specified group will be assigned to so that it can perform some actions specific to that environment.
         * @param {string} dialCodeGroupName The dial code group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceDatacenterEnvironmentGet: function (dialCodeGroupName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceDatacenterEnvironmentGet(dialCodeGroupName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the service endpoint for the specified body and service. This maps to the slsServiceEndpointGet API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} bodyId The ID of a body.
         * @param {string} originRequestId A unique request identifier.
         * @param {string} service The name of a specific service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointGet: function (applicationName, bodyId, originRequestId, service, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceEndpointGet(applicationName, bodyId, originRequestId, service, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all service endpoints for the specified body. This maps to the slsServiceEndpointSearch API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} bodyId The ID of a body.
         * @param {string} originRequestId A unique request identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointSearch: function (applicationName, bodyId, originRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceEndpointSearch(applicationName, bodyId, originRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of service endpoints that are global to the region.  The same list is returned for all callers.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} originRequestId A unique request identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceGlobalEndpointSearch: function (applicationName, originRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceGlobalEndpointSearch(applicationName, originRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns an ordered list of service endpoints for the servicelogin service for the specified body. This maps to the slsServiceLoginEndpointSearch API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} originRequestId A unique request identifier.
         * @param {string} [deviceType] The device type of a body.
         * @param {string} [domain] The domain of a body.
         * @param {string} [softwareVersion] The software version of a body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLoginEndpointSearch: function (applicationName, originRequestId, deviceType, domain, softwareVersion, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceLoginEndpointSearch(applicationName, originRequestId, deviceType, domain, softwareVersion, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         * Accepts a list of body IDs and returns the current location the body is connected to. If the service could not determine the current location, the bodyId is omitted from the response. This maps to the slsBodyCurrentEndpointSearch API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {Array<string>} bodyIds An array of body IDs.
         * @param {string} originRequestId A unique request identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceCurrentEndpointSearch: function (applicationName, bodyIds, originRequestId, options) {
            return localVarFp.serviceCurrentEndpointSearch(applicationName, bodyIds, originRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Accepts a group name and returns the inception datacenter and morpheus environment for the mrpcsecure service assigned to that group.  This API is a special case used by the provisioning system to determine which environment a body using the specified group will be assigned to so that it can perform some actions specific to that environment.
         * @param {string} dialCodeGroupName The dial code group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceDatacenterEnvironmentGet: function (dialCodeGroupName, options) {
            return localVarFp.serviceDatacenterEnvironmentGet(dialCodeGroupName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the service endpoint for the specified body and service. This maps to the slsServiceEndpointGet API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} bodyId The ID of a body.
         * @param {string} originRequestId A unique request identifier.
         * @param {string} service The name of a specific service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointGet: function (applicationName, bodyId, originRequestId, service, options) {
            return localVarFp.serviceEndpointGet(applicationName, bodyId, originRequestId, service, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all service endpoints for the specified body. This maps to the slsServiceEndpointSearch API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} bodyId The ID of a body.
         * @param {string} originRequestId A unique request identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceEndpointSearch: function (applicationName, bodyId, originRequestId, options) {
            return localVarFp.serviceEndpointSearch(applicationName, bodyId, originRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of service endpoints that are global to the region.  The same list is returned for all callers.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} originRequestId A unique request identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceGlobalEndpointSearch: function (applicationName, originRequestId, options) {
            return localVarFp.serviceGlobalEndpointSearch(applicationName, originRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns an ordered list of service endpoints for the servicelogin service for the specified body. This maps to the slsServiceLoginEndpointSearch API.
         * @param {string} applicationName The application name of the device making the request.
         * @param {string} originRequestId A unique request identifier.
         * @param {string} [deviceType] The device type of a body.
         * @param {string} [domain] The domain of a body.
         * @param {string} [softwareVersion] The software version of a body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLoginEndpointSearch: function (applicationName, originRequestId, deviceType, domain, softwareVersion, options) {
            return localVarFp.serviceLoginEndpointSearch(applicationName, originRequestId, deviceType, domain, softwareVersion, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Accepts a list of body IDs and returns the current location the body is connected to. If the service could not determine the current location, the bodyId is omitted from the response. This maps to the slsBodyCurrentEndpointSearch API.
     * @param {DefaultApiServiceCurrentEndpointSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.serviceCurrentEndpointSearch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).serviceCurrentEndpointSearch(requestParameters.applicationName, requestParameters.bodyIds, requestParameters.originRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Accepts a group name and returns the inception datacenter and morpheus environment for the mrpcsecure service assigned to that group.  This API is a special case used by the provisioning system to determine which environment a body using the specified group will be assigned to so that it can perform some actions specific to that environment.
     * @param {DefaultApiServiceDatacenterEnvironmentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.serviceDatacenterEnvironmentGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).serviceDatacenterEnvironmentGet(requestParameters.dialCodeGroupName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the service endpoint for the specified body and service. This maps to the slsServiceEndpointGet API.
     * @param {DefaultApiServiceEndpointGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.serviceEndpointGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).serviceEndpointGet(requestParameters.applicationName, requestParameters.bodyId, requestParameters.originRequestId, requestParameters.service, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all service endpoints for the specified body. This maps to the slsServiceEndpointSearch API.
     * @param {DefaultApiServiceEndpointSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.serviceEndpointSearch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).serviceEndpointSearch(requestParameters.applicationName, requestParameters.bodyId, requestParameters.originRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of service endpoints that are global to the region.  The same list is returned for all callers.
     * @param {DefaultApiServiceGlobalEndpointSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.serviceGlobalEndpointSearch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).serviceGlobalEndpointSearch(requestParameters.applicationName, requestParameters.originRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns an ordered list of service endpoints for the servicelogin service for the specified body. This maps to the slsServiceLoginEndpointSearch API.
     * @param {DefaultApiServiceLoginEndpointSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.serviceLoginEndpointSearch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).serviceLoginEndpointSearch(requestParameters.applicationName, requestParameters.originRequestId, requestParameters.deviceType, requestParameters.domain, requestParameters.softwareVersion, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
